module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"selectLabel":"Select","selectedLabel":"Selected","deselectLabel":"Remove","tagPh":"Add new item"},"et":{"selectLabel":"Select","selectedLabel":"Selected","deselectLabel":"Remove","tagPh":"Add new item"},"ru":{"selectLabel":"Select","selectedLabel":"Selected","deselectLabel":"Remove","tagPh":"Add new item"}}')
  delete Component.options._Ctor
}
